exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/nicholasgerard/Documents/Quibbl/quibbl/src/app/contact/contact.component.scss
// module id = ../../../../../src/app/contact/contact.component.scss
// module chunks = main